// extracted by mini-css-extract-plugin
export default {"close_button":"close-button_close_button__qY5CX"};